export default __webpack_public_path__ + "static/lester-4a14102988ef3f387ebff88b38e0c46a.png";